import {connect} from "react-redux";
import PaymentRaise from "./PaymentRaise";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../services/redux/fileUpload/action";
import {loanPaymentRaiseRequest, loanAccountRequest, loanUndertakingRequest, bankListRequest, loanTranchesRequest, loanPaymentRaiseUpdateRequest, loanApplicationByIdRequest, loanApprovalRequestRequest} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    bankListResponse: state.CarLoan.bankListResponse,
    loanApplicationUpdateResponse: state.CarLoan.loanApplicationUpdateResponse,
    loanAccountResponse: state.CarLoan.loanAccountResponse,
    loanUndertakingResponse: state.CarLoan.loanUndertakingResponse,
    loanPaymentRaiseUpdateResponse: state.CarLoan.loanPaymentRaiseUpdateResponse,
    ucdCaseByIdResponse: state.CarLoan.loanApplicationByIdResponse,
    loanTranchesResponse: state.CarLoan.loanTranchesResponse,
    loanPaymentRaiseResponse: state.CarLoan.loanPaymentRaiseResponse,
    loanApprovalRequestResponse: state.CarLoan.loanApprovalRequestResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            bankListRequest,
            loanUndertakingRequest,
            loanAccountRequest,
            loanPaymentRaiseRequest,
            loanTranchesRequest,
            loanPaymentRaiseUpdateRequest,
            loanApplicationByIdRequest,
            loanApprovalRequestRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRaise);
